import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() detail: string;
  @Input() errors: Array<string>;
  @Input() traceId: string;

  working: boolean = false;

  constructor(private activeModal: NgbActiveModal) { }

  close() {
    this.activeModal.close();
  }

  sendDetails() {
    this.activeModal.close({ sendDetails: true });
  }
}
